import React from 'react';
import { Track, createLocalVideoTrack, VideoQuality } from 'livekit-client';
import { BackgroundBlur } from '@livekit/track-processors';
import { useState, useEffect, useRef } from 'react';

/**
 * LiveKit-powered local camera preview (does NOT join a room)
 */
export default function LiveKitLocalCameraPreview() {
  const videoRef = useRef(null);
  const [videoTrack, setVideoTrack] = useState(null);

  useEffect(() => {
    let track;
    let stopped = false;
    async function startLiveKitPreview() {
      try {
        track = await createLocalVideoTrack();
        // Apply background blur processor
        try {
          const processor = BackgroundBlur(10); // Adjust blur level as needed
          await track.setProcessor(processor);
          track.setPublishingQuality && track.setPublishingQuality(VideoQuality.HIGH);
        } catch (e) {
          console.warn('Could not apply background blur:', e);
        }
        if (!stopped && videoRef.current) {
          track.attach(videoRef.current);
          setVideoTrack(track);
        }
      } catch (err) {
        console.error('LiveKit: Could not start local camera preview:', err);
      }
    }
    startLiveKitPreview();
    return () => {
      stopped = true;
      if (track) {
        track.detach();
        track.stop();
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '1rem', background: '#000' }}
      data-lk-local-preview
    />
  );
}
